<template>
  <modal>
    <template slot="header">
      <md-button
        class="md-just-icon md-round modal-default-button"
        @click="closeModal"
        style="right: 20px; top: 20px;"
      >
        <md-icon>clear</md-icon>
      </md-button>
    </template>

    <template slot="body">
      <md-card>
        <md-card-header class="md-card-header-icon md-card-header-primary">
          <div class="card-icon">
            <md-icon>email</md-icon>
          </div>
          <h4 class="title" style="text-align: left">
            {{ $t("Send Emails to Selected Users") }}
          </h4>
          <p style="text-align: left">
            {{
              users.length === 0
                ? $t("You are about to send emails to all users")
                : $t("You are about to send emails to * users", {
                    count: users.length
                  })
            }}
          </p>
        </md-card-header>

        <md-card-content>
          <validated-autocomplete-input
            :options="templateNames"
            v-model="selectedTemplate"
            label="Template"
            name="template"
            validation-rules="required"
          />
          <md-checkbox v-model="subscribersOnly">
            {{ $t("Send emails only to newsletter subscribers") }}
          </md-checkbox>
        </md-card-content>
      </md-card>
    </template>

    <template slot="footer">
      <md-button @click="sendTestEmail" style="margin-right: 20px;">
        {{ $t("Send Test Email") }}
      </md-button>
      <md-button class="md-primary" @click="sendEmails">
        {{ $t("Send Emails") }}
      </md-button>
    </template>
  </modal>
</template>

<script>
import { Modal } from "@/components";
import swal from "sweetalert2";
import ValidatedAutocompleteInput from "@/components/Inputs/ValidatedAutocompleteInput.vue";

export default {
  $_veeValidate: {
    validator: "new"
  },
  components: { ValidatedAutocompleteInput, Modal },
  props: {
    userEmail: {
      type: String,
      required: true
    },
    users: {
      type: Array,
      required: true
    },
    toAll: { type: Boolean, default: false }
  },
  data() {
    return {
      subscribersOnly: false,
      templates: [],
      templateNames: [],
      selectedTemplate: ""
    };
  },
  async mounted() {
    const response = await this.$store.dispatch("auth/getEmailTemplates");

    if (response.error) {
      return swal.fire({
        title: this.$t("Warning"),
        text: this.$t(
          "Dynamic email template names could not be retrieved, but you can enter the template id manually"
        ),
        type: "warning",
        confirmButtonClass: "md-button md-warning",
        buttonsStyling: false
      });
    }

    this.templates = await this.$store.dispatch("auth/getEmailTemplates");
    this.templateNames = this.templates.map(template => template.name);
  },
  methods: {
    closeModal() {
      this.$emit("closeModal");
    },
    async sendEmails() {
      const isValid = await this.$validator.validateAll();

      if (!isValid) {
        return;
      }

      if (this.toAll) {
        await this.send([]);
        this.closeModal();
        return;
      }

      const filteredUsersList = this.subscribersOnly
        ? this.users.filter(user => user.newsletter === true)
        : this.users;
      const emailsForSend = filteredUsersList.map(user => user.email);

      if (emailsForSend.length === 0) {
        await swal.fire({
          title: this.$t("Warning"),
          text: this.$t(
            "None of the selected users are subscribed to the Newsletter"
          ),
          type: "warning",
          confirmButtonClass: "md-button md-warning",
          buttonsStyling: false
        });

        return;
      }

      await this.send(emailsForSend);
      this.closeModal();
    },
    async sendTestEmail() {
      const isValid = await this.$validator.validateAll();

      if (!isValid) {
        return;
      }

      await this.send([this.userEmail], true);
    },
    async send(emails, test = false) {
      const templateFromList = this.templates.find(
        template => template.name === this.selectedTemplate
      );
      const selectedTemplateId = templateFromList
        ? templateFromList.id
        : this.selectedTemplate;

      let response = {};
      if (emails.length === 0) {
        response = await this.$store.dispatch("auth/sendEmailsToAll", {
          template: selectedTemplateId,
          newsletter_only: this.subscribersOnly
        });
      } else {
        response = await this.$store.dispatch("auth/sendEmails", {
          template: selectedTemplateId,
          emails
        });
      }

      if (response.error) {
        return swal.fire({
          title: this.$t("Error"),
          text: this.$t(
            test
              ? "Could not send a test email"
              : "Could not send template emails"
          ),
          type: "error",
          confirmButtonClass: "md-button md-error",
          buttonsStyling: false
        });
      }

      await swal.fire({
        title: this.$t("Acknowledgement"),
        text: this.$t(
          test
            ? "A test email have been sent to you, check your mailbox!"
            : "The emails have been sent to selected users!"
        ),
        type: "success",
        confirmButtonClass: "md-button md-success",
        buttonsStyling: false
      });
    }
  }
};
</script>
